module.exports = __webpack_public_path__ + "img/377.4f44c36e.png";